import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class CreateIterableIteratorStructuredStorageHelper extends StructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const size = sb.scope.addUnique();
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.getStructuredStorageSize({ type: this.type }));
        sb.scope.set(sb, node, options, size);
        sb.emitHelper(node, optionsIn, sb.helpers.createIterableIteratorStructuredStorageBase({
            type: this.type,
            handleNext: (innerOptions) => {
                sb.scope.get(sb, node, innerOptions, size);
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.handleValueStructuredStorage);
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitHelper(node, innerOptions, sb.helpers.wrapArray);
                sb.emitOp(node, 'SWAP');
            },
        }));
    }
}

//# sourceMappingURL=CreateIterableIteratorStructuredStorageHelper.js.map
